import { render } from "./StatisticBox.vue?vue&type=template&id=723e9d04&scoped=true"
import script from "./StatisticBox.vue?vue&type=script&lang=js"
export * from "./StatisticBox.vue?vue&type=script&lang=js"

import "./StatisticBox.vue?vue&type=style&index=0&id=723e9d04&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723e9d04"]])

export default __exports__